namespace Serenity {
    export interface GridPersistanceFlags {
        groupColumns?: boolean;
    }

    export interface PersistedGridSettings {
        groupColumns?: string[];
    }
    
    export interface DraggableGroupingMixinOptions {
        grid: Serenity.DataGrid<any, any>;
    }

    function sortBy(field: string, reverse?: boolean, primer?: (value: any) => any) {
    
	   var key = function (x: any) {
           return primer ? primer(x[field]) : x[field]
       };
	
	   return function (a: any, b: any) {
	       var A = key(a), B = key(b);
	       return (A < B ? -1 : (A > B ? 1 : 0)) * [1,-1][+!!reverse];
	   }
	};

    export class DraggableGroupingMixin {
        
        public readonly plugin: Slick.Plugins.DraggableGrouping;

        constructor(options: DraggableGroupingMixinOptions) {
            var dg = options.grid;

            var plugin = this.plugin = new Slick.Plugins.DraggableGrouping({
                getAllColumns: () => (dg as any).allColumns
            });

            dg.slickGrid.registerPlugin(plugin);

            plugin.onGroupChanged.subscribe(() => {
                (dg as any).persistSettings(null);
            });

            var oldCurrentSettings = (dg as any).getCurrentSettings;
            (dg as any).getCurrentSettings = function (flags: GridPersistanceFlags) {
                var settings = oldCurrentSettings.apply(dg, [flags]);

                if (flags == null || flags.groupColumns == null || flags.groupColumns) {
                    var grouping = (dg.view as any).getGrouping() as Slick.GroupInfo<any>[] || [];
                    settings['groupColumns'] = grouping.map(x => x.getter)
                        .filter(x => x != null && typeof x == "string");
                }

                return settings;
            };

            function loadGroupCols(groupColsToLoad: string[]) { 
                if (groupColsToLoad == null)
                    return;
                
                var columns = (dg as any).allColumns as Slick.Column[];

                var groupCols = groupColsToLoad
                    .map(x => Q.tryFirst(columns, z => z.id == x))
                    .filter(x => x != null);
                    
                var groupings = groupCols.map((e: Slick.Column) => {
                    if (e['grouping'] == null)
                        e['grouping'] = plugin.getGroupingFor(e);

                    return e['grouping'];
                });

                dg.view.setGrouping(groupings as any);
                plugin.setDroppedGroups(groupCols.map(x => x.id));
                dg.slickGrid.invalidate();
            };

            function getDefaultGroupCols() {
                var colsWithOrder = (dg as any).allColumns.filter((x: Slick.Column) => x.sourceItem != null &&
                    x.sourceItem.groupOrder != null) as Slick.Column[];
                if (colsWithOrder.length) {
                    return colsWithOrder.sort(sortBy('groupOrder')).map(x => x.id);
                }
                return null;
            }

            var oldRestoreSettings = (dg as any).restoreSettings;
            (dg as any).restoreSettings = function (settings?: PersistedGridSettings, flags?: GridPersistanceFlags) {
                oldRestoreSettings.apply(dg, [settings, flags]);

                if (!(flags == null || flags.groupColumns == null || flags.groupColumns))
                    return;

                var groupColsToLoad: string[] = null;

                if (settings == null) {
                    var storage = this.getPersistanceStorage();
                    if (storage != null) {
                        var json = Q.trimToNull(storage.getItem(this.getPersistanceKey()));
                        if (json) {
                            groupColsToLoad = (JSON.parse(json) || {}).groupColumns;
                        }
                    }
                }
                else
                    groupColsToLoad = settings.groupColumns;

                if (groupColsToLoad == null) {
                    groupColsToLoad = getDefaultGroupCols();
                }

                loadGroupCols(groupColsToLoad);
                
            };
        }
    }
}